import Tools from '../Tools/Tools';
/**
 * Třída, která umožňuje validaci/zobrazování chybových hlášek inputů.
 */
class Validation {
	/**
	 * Naslouchá na změny inputu a validuje ho podle zadaného pravidla.
	 * @param {Element} elem
	 * @param {number} ruleType
	 * 0 - input není prázdný
	 */
	static checkInputValidity(elem, ruleType = 0) {
		if (this.hasInputErrorMsg(elem)) {
			elem.addEventListener('input', (e) => {
				switch (ruleType) {
					case 0:
						if (e.target.value.length) {
							Validation.hideInputError(e.target);
						} else {
							Validation.showInputError(e.target);
						}

						break;
				}
			});
		}
	}

	/**
	 * Schová error inputu, pokud existuje.
	 * @param {Element} elem
	 */
	static hideInputError(elem) {
		if (this.hasInputErrorMsg(elem)) {
			elem.nextElementSibling.classList.add('is-invisible');
		}

		elem.classList.remove('is-invalid');
	}

	/**
	 * Zobrazí error inputu, pokud existuje.
	 * @param {Element} elem
	 */
	static showInputError(elem) {
		if (this.hasInputErrorMsg(elem)) {
			elem.nextElementSibling.classList.remove('is-invisible');
		}

		elem.classList.add('is-invalid');
	}

	/**
	 * Zjistí zda má element vygenerovanou chybovou hlášku.
	 * @param {Element} elem
	 * @return {boolean}
	 */
	static hasInputErrorMsg(elem) {
		return elem && elem.nextElementSibling && elem.nextElementSibling.classList.contains('Error');
	}

	/**
	 * Pokud element nemá chybovou hlášku, tak jí vygeneruje.
	 * @param {Element} elem
	 * @param {string} text
	 */
	static addInputErrorMsg(elem, text = 'Error') {
		if (!this.hasInputErrorMsg(elem)) {
			const err = Tools.createElement('p', {
				class: 'Error Error--input',
				innerText: text,
			});

			Tools.insertAfter(err, elem);
			elem.classList.add('is-invalid');
		} else {
			this.showInputError(elem);
		}
	}
}

export default Validation;
